import React from 'react';
import Hero from '../../components/Hero/Hero';
import HowItWorks from '../../components/HowItWorks/HowItWorks';
import Features from '../../components/Features/Features';
import Trust from '../../components/Trust/Trust';
import Pricing from '../../components/Pricing/Pricing';
import FinalCTA from '../../components/FinalCTA/FinalCTA';
import Footer from '../../components/Footer/Footer';
import Separator from '../../components/Separator/Separator';
import Brands from '../../components/Brands/Brands';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <Separator />
      <Pricing />
      <Separator />
      <Features />
      <Separator />
      <Trust />
      <Separator />
      <HowItWorks />
      <Separator />
      <FinalCTA />
      <Separator />
      <Brands />
      <Separator />
      <Footer />
    </div>
  );
};

export default Home;
